import React, { useEffect, useRef, useState } from "react";
import AudioPlayer from "react-h5-audio-player";
import { HiPause, HiPlay } from "react-icons/hi2";
import "react-h5-audio-player/lib/styles.css";
import "./audio.css";

export default function Audio({ url }) {
    const playerRef = useRef(null);
    const [isSafari, setIsSafari] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        // More reliable Safari detection (includes both Mac and iOS Safari)
        const isSafariBrowser = 
            /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || 
            (navigator.userAgent.includes('AppleWebKit') && !navigator.userAgent.includes('Chrome'));
        
        setIsSafari(isSafariBrowser);
        
        // Safari requires user interaction before playing audio
        if (isSafariBrowser && playerRef.current) {
            const audioElement = playerRef.current.audio.current;
            
            // Force audio to be loaded
            if (audioElement) {
                audioElement.preload = "auto";
                
                // Add specific handling for Safari audio loading
                const handleCanPlay = () => {
                    setIsLoaded(true);
                };
                
                const handleError = (e) => {
                    console.error("Audio loading error:", e);
                    setError(true);
                };
                
                audioElement.addEventListener('canplaythrough', handleCanPlay);
                audioElement.addEventListener('error', handleError);
                
                // Clean up event listeners
                return () => {
                    if (audioElement) {
                        audioElement.removeEventListener('canplaythrough', handleCanPlay);
                        audioElement.removeEventListener('error', handleError);
                    }
                };
            }
        }
    }, []);

    // Force a reload of the audio element if there was an error
    const handleRetry = () => {
        if (playerRef.current && playerRef.current.audio.current) {
            setError(false);
            const audioElement = playerRef.current.audio.current;
            audioElement.load();
        }
    };

    return (
        <div className="whatsapp_preview_custom_audio_player">
            {error ? (
                <div className="audio-error">
                    <p>Failed to load audio</p>
                    <button onClick={handleRetry}>Retry</button>
                </div>
            ) : (
                <AudioPlayer
                    ref={playerRef}
                    autoPlayAfterSrcChange={false}
                    showJumpControls={false}
                    customAdditionalControls={[]}
                    customVolumeControls={[]}
                    autoPlay={false}
                    layout="horizontal-reverse"
                    style={{ background: "transparent", border: "none", boxShadow: "none", padding: "0", width: "100%" }}
                    src={url}
                    playsInline={true}
                    preload="metadata"
                    customIcons={{
                        play: <HiPlay style={{ fontSize: "1.5rem", color: "#998E8D" }} />,
                        pause: <HiPause style={{ fontSize: "1.5rem", color: "#998E8D" }} />,
                    }}
                    onError={(e) => {
                        console.error("Audio player error:", e);
                        setError(true);
                    }}
                    onCanPlayThrough={() => {
                        setIsLoaded(true);
                        if (isSafari && playerRef.current && playerRef.current.audio.current) {
                            // For Safari, ensure the audio element is properly initialized
                            const audioElement = playerRef.current.audio.current;
                            
                            // A small timeout can help Safari process the audio properly
                            setTimeout(() => {
                                try {
                                    audioElement.load();
                                } catch (err) {
                                    console.error("Error loading audio in Safari:", err);
                                }
                            }, 100);
                        }
                    }}
                />
            )}
        </div>
    );
}
